import { switchMap } from 'rxjs/operators';
import {
  Component, Input, Output, OnInit, EventEmitter, Pipe,
  ChangeDetectorRef, Renderer2,
  ViewChild, ViewEncapsulation, QueryList, ViewChildren, HostListener, ElementRef
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { each, filter as _filter, uniqBy as _uniqBy, cloneDeep } from 'lodash-es';

//import 'rxjs/add/operator/map';
import dayjs from 'dayjs';
import { FormsModule, FormGroup, FormControl, Validators, NgForm } from '@angular/forms';

import { DomSanitizer } from '@angular/platform-browser';
import { Params } from "@angular/router";
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import { TimerObservable } from "rxjs/observable/TimerObservable";
import { ePayService } from "../Service/ePayService";
import { formService } from '../Service/formService';
import { PreQuestionaireComponent } from '../PreQuestionaire/preQuestionaire.component';
import { Session_BillingModel } from '../Models/Model/Session_BillingModel';
import { Session_PaymentModel } from '../Models/Model/Session_PaymentModel';
import { DatePipe } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { Observable, observable, of } from 'rxjs';
import { Token } from '../Models/Token';
import { Session_AppleSubmissionModel } from '../Models/Model/Session_AppleSubmissionModel';
import jquery from 'jquery';
import { Session_Credit_Card_RequestModel } from '../Models/Model/Session_Credit_Card_RequestModel';
import { NgRecaptcha3Service } from 'ng-recaptcha3'
import { CaptchaComponent } from '../Captcha/Captcha.component';
import { Session_Device } from '../Models/Model/Session_Device';
import { Session_ePaySessionModel } from '../Models/Model/Session_ePaySessionModel';
import { Session_PreQuestionNumberModel } from '../Models/Model/Session_PreQuestionNumberModel';
import { DynamicDirective } from '../DynamicDirective/DynamicDirective'
import { ABAValidator } from '../ABAValidator/ABAValidator'
import { ApplePayComponent } from '../ApplePay/applepay.component'
import { GooglePayComponent } from '../GooglePay/gogglepay.component'
import { CreditCardComponent } from '../CreditCard/creditcard.component'
import { StatesComponent } from '../State/States.component'
import { CurrencyPipe } from '@angular/common';

declare var Accept: any;

@Component({
  selector: 'forms',
  templateUrl: 'form.component.html',
  styleUrls: ['form.component.css', '../../styles.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DatePipe, DynamicDirective, ABAValidator],
  imports: [PreQuestionaireComponent, ApplePayComponent, CreditCardComponent, StatesComponent, FormsModule,
    DynamicDirective, CurrencyPipe, GooglePayComponent]
})
export class FormComponent {
  public account_Numberdup: string = '';
  public agree: boolean = false;
  private _sessionid: string = '';
  public isLoading: Boolean = true;
  public cssLoading: boolean = true;
  public RequiredAnswerMessage: string = '';
  private iFrameWidth: number = 0;
  public isSubmitting: boolean = false;
  public isCardDataValid: boolean = false;
  public invalidmessages = [];
  public refreshScreen: boolean = false;
  public isTerminalSubmitting: boolean = false;
  private height = 0;
  private prevHeight = 0;
  private width = 0;
  private prevWidth = 0;
  private iFrame: any;
  public allowAgree: boolean = false;
  public counter: number = 0;
  public isSending: boolean = false;
  public changesDetected: boolean = false;
  public routingnumbervalid = false;
  private secureData = new Token();
  private valid: boolean = false;
  public allowRecurring: boolean = false;
  private mouseMoved = false;
  private startTime: number = 0;
  private _selectedDevice: any;
  paymentOptions: Session_PaymentModel[] = [];

  @ViewChild(NgForm, { static: false }) form: NgForm | null | undefined = undefined;
  @ViewChildren(PreQuestionaireComponent) PreQuestionaireComponents: QueryList<PreQuestionaireComponent> | null | undefined = undefined;
  @ViewChild('billing_zipcode', { static: false }) billing_zipcode: any;
  @ViewChild('billing_firstname', { static: false }) billing_firstname: any;
  @ViewChild('billing_lastname', { static: false }) billing_lastname: any;
  @ViewChild('billing_address1', { static: false }) billing_address1: any;
  @ViewChild('billing_city', { static: false }) billing_city: any;
  @ViewChild('billing_phone', { static: false }) billing_phone: any;
  @ViewChild('selectedDevice', { static: false }) dropdownlist: any;
  
  @Input()
  get sessionid(): string {
    return this._sessionid;
  }
  set sessionid(value: string) {
    this._sessionid = value;
  }

  get EPayService(): ePayService {
    return this.FormService.EPayService;
  }

  get carddata() {
    return this.secureData;
  }
  set carddata(cardData: Token) {
    this.secureData = cardData;
    if (this.secureData.valid != null && this.secureData.valid != undefined) {
      this.isCardDataValid = this.secureData.valid;
    }
    else {
      this.isCardDataValid = false;
    }    
  }

  //Save the users current session on unload event
  @HostListener('window:beforeunload', ['$event'])
  saveSession($event: any) {
    this.FormService.saveSession();
  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    this.mouseMoved = true;
  }
  @HostListener('window:touchmove', ['$event'])
  touchmove(event: any) {
    this.mouseMoved = true;
  }

  constructor(
    private recaptcha3: NgRecaptcha3Service,
    private sanitizer: DomSanitizer,
    private cdRef: ChangeDetectorRef,
    //private route: ActivatedRoute,
    private FormService: formService,
    private dialog: MatDialog,
    private title: Title) {
  }

  private canMakePayment = false;
  private request: PaymentRequest | null | undefined = undefined;

  ngOnInit() {
    this.iFrame = (window.self !== window.top);
    $(".form").hide();
    this.isLoading = true;
    if (this.EPayService.sessionId) {
      this.FormService.LoadSession(this.EPayService.sessionId, this.iFrame).subscribe(
        data => {
          if (data.paymentPage.captchakey) {
            this.recaptcha3.init(data.paymentPage.captchakey).then(status => {
              // status: success/error
              // success - script is loaded and greaptcha is ready
              // error - script is not loaded
              console.log(status)
            });
          }
          //Give everything time to load
          window.setTimeout(() => {
            this.cssLoading = false;
            this.isLoading = false;
            jquery(".form").fadeIn(500);
            jquery(".loader").fadeOut(250);
          }, 1000);
        });
    }
    //Listen for a refresh event being called from a parent iframe
    window.addEventListener("message", (event) => {
      //console.info('listening', event);
      if (event.data) {
        if (event.data.action === "refresh") {
          if (event.data.uid === this.EPayService.ePay?.xmlPayment.validation.uid) {
            this.FormService.Refresh(event.data.uid, event.data.config).subscribe(
              () => {
                this.cdRef.markForCheck();
                this.cdRef.detectChanges();
              });
          }
        }
      }
    });
    this.startTime = Date.now();


    const payments = this.EPayService.ePay?.xmlPayment.paymentOptions.payment ?? [];
    // Strong typing + native filter
    this.paymentOptions = payments.filter((p: Session_PaymentModel) => !!p.enabled);

  }


  get account_Number(): string {
    return this.EPayService.ePay?.paymentPage?.ach?.accountNumber ?? '';
  }
  set account_Number(val: string) {
    // Ensure nested objects exist
    if (this.EPayService?.ePay?.paymentPage.ach) {
      this.EPayService.ePay.paymentPage.ach.accountNumber = val;
    }
  }

  get routing_Number(): string {
    return this.EPayService.ePay?.paymentPage?.ach?.routingNumber ?? '';
  }
  set routing_Number(val: string) {
    // Ensure nested objects exist
    if (this.EPayService?.ePay?.paymentPage.ach) {
      this.EPayService.ePay.paymentPage.ach.routingNumber = val;
      this.routingnumbervalid = this.routingNumberValid(this.EPayService.ePay.paymentPage.ach.routingNumber);
    }
  }

  //vaidatate routing #
  routingNumberValid = (number: string) : boolean => {
    if (number) {
      if (number.length !== 9) {
        return false;
      }
      if (number.charAt(0) === '5') {
        return false;
      }

      let abaRegex = /^[012346789][0-9]{8}$/;
      let regEx = new RegExp(abaRegex);
      if (!regEx.test(number)) {
        return false;
      }
      return this._passesLuhnCheck(number);
    }
    else {
      return false;
    }
  }

  //vaidatate routing # with Luhn
  _passesLuhnCheck = (routing: string) : boolean => {
    var checksumTotal = (7 * (parseInt(routing.charAt(0), 10) + parseInt(routing.charAt(3), 10) + parseInt(routing.charAt(6), 10))) +
      (3 * (parseInt(routing.charAt(1), 10) + parseInt(routing.charAt(4), 10) + parseInt(routing.charAt(7), 10))) +
      (9 * (parseInt(routing.charAt(2), 10) + parseInt(routing.charAt(5), 10) + parseInt(routing.charAt(8), 10)));
    var checksumMod = checksumTotal % 10;
    if (checksumMod !== 0) return false;
    return true;
  }

  get account_Name(): string | null | undefined {
    return this.EPayService.ePay?.paymentPage?.ach?.accountName ?? '';
  }
  set account_Name(val: string | null | undefined) {
    // Ensure nested objects exist
    if (this.EPayService?.ePay?.paymentPage.ach) {
      this.EPayService.ePay.paymentPage.ach.accountName = val;
    }
  }

  get cardHolderName(): string | null | undefined {
    return this.EPayService.ePay?.paymentPage?.cardHolderName ?? '';
  }
  set cardHolderName(val: string | null | undefined) {
    // Ensure nested objects exist
    if (this.EPayService?.ePay?.paymentPage) {
      this.EPayService.ePay.paymentPage.cardHolderName = val;
    }
  }

  get email(): string | null | undefined {
    return this.EPayService.ePay?.paymentPage?.email ?? '';
  }
  set email(val: string | null | undefined) {
    // Ensure nested objects exist
    if (this.EPayService?.ePay?.paymentPage) {
      this.EPayService.ePay.paymentPage.email = val;
    }
  }


  get address_1(): string | null | undefined {
    return this.EPayService.ePay?.paymentPage?.address1 ?? '';
  }
  set address_1(val: string | null | undefined) {
    // Ensure nested objects exist
    if (this.EPayService?.ePay?.paymentPage) {
      this.EPayService.ePay.paymentPage.address1 = val;
    }
  }

  get address_2(): string | null | undefined {
    return this.EPayService.ePay?.paymentPage?.address2 ?? '';
  }
  set address_2(val: string | null | undefined) {
    // Ensure nested objects exist
    if (this.EPayService?.ePay?.paymentPage) {
      this.EPayService.ePay.paymentPage.address2 = val;
    }
  }

  get city(): string | null | undefined {
    return this.EPayService.ePay?.paymentPage?.city ?? '';
  }
  set city(val: string | null | undefined) {
    // Ensure nested objects exist
    if (this.EPayService?.ePay?.paymentPage) {
      this.EPayService.ePay.paymentPage.city = val;
    }
  }

  get state(): string | null | undefined {
    return this.EPayService.ePay?.paymentPage?.state ?? '';
  }
  set state(val: string | null | undefined) {
    // Ensure nested objects exist
    if (this.EPayService?.ePay?.paymentPage) {
      this.EPayService.ePay.paymentPage.state = val;
    }
  }

  get zipCode(): string | null | undefined {
    return this.EPayService.ePay?.paymentPage?.zipCode ?? '';
  }
  set zipCode(val: string | null | undefined) {
    // Ensure nested objects exist
    if (this.EPayService?.ePay?.paymentPage) {
      this.EPayService.ePay.paymentPage.zipCode = val;
    }
  }

  get phone(): string | null | undefined {
    return this.EPayService.ePay?.paymentPage?.phone ?? '';
  }
  set phone(val: string | null | undefined) {
    // Ensure nested objects exist
    if (this.EPayService?.ePay?.paymentPage) {
      this.EPayService.ePay.paymentPage.phone = val;
    }
  }

  get outsideUS(): boolean {
    return this.EPayService.ePay?.paymentPage?.outsideUS ?? false;
  }
  set outsideUS(val: boolean) {
    // Ensure nested objects exist
    if (this.EPayService?.ePay?.paymentPage) {
      this.EPayService.ePay.paymentPage.outsideUS = val;
    }
  }  

  get company(): string | null | undefined {
    return this.EPayService.ePay?.paymentPage?.company ?? '';
  }
  set company(val: string | null | undefined) {
    // Ensure nested objects exist
    if (this.EPayService?.ePay?.paymentPage) {
      this.EPayService.ePay.paymentPage.company = val;
    }
  }

  get firstName(): string | null | undefined {
    return this.EPayService.ePay?.paymentPage?.firstName ?? '';
  }
  set firstName(val: string | null | undefined) {
    // Ensure nested objects exist
    if (this.EPayService?.ePay?.paymentPage) {
      this.EPayService.ePay.paymentPage.firstName = val;
    }
  }

  get lastName(): string | null | undefined {
    return this.EPayService.ePay?.paymentPage?.lastName ?? '';
  }
  set lastName(val: string | null | undefined) {
    // Ensure nested objects exist
    if (this.EPayService?.ePay?.paymentPage) {
      this.EPayService.ePay.paymentPage.lastName = val;
    }
  }
  public IotpTransId() {
    if (this.EPayService.ePay?.iotp?.iotpTransId) {
      if (this.EPayService.ePay.iotp.iotpTransId.length >= 14) {
        return this.EPayService.ePay.iotp.iotpTransId.substr(0, 14);
      }
    }
  }

  public TotalAmount() {
    if (this.EPayService.ePay?.paymentPage.totalAmount) {
      return this.EPayService.ePay.paymentPage.totalAmount;
    }
    return 0;
  }

  public PaymentDate() {
    if (this.EPayService.ePay?.iotp?.paymentDate) {
      return this.EPayService.ePay?.iotp?.paymentDate;
    }
  }

  public onPaymentOptionClick(paymentOption: Session_PaymentModel): void {
    // Ensure service objects exist before assignment
    if (this.EPayService.ePay?.paymentPage) {
      // Safely parse the option to a number
      const value = typeof paymentOption?.option === 'number'
        ? paymentOption.option
        : parseInt(String(paymentOption?.option ?? '0'), 10);

      this.EPayService.ePay.paymentPage.paymentOption = isNaN(value) ? null : value;

      this.ReCalcuatePaymentAmount();
    }
  }


  trackByPayment = (index: number, item: Session_PaymentModel) =>
    item.option ?? item.type ?? index;


  IsSnapPay = () => {
    var results = false;
    if (this.EPayService) {
      each(this.EPayService.ePay?.paymentPage.credit_card, (credit_card: Session_Credit_Card_RequestModel) => {
        if (credit_card.snappay) {
          results = true;
        }
      });
    }
    return results;
  }

  //Get the next section
  NextSection = () => {
    this.FormService.NextSection();
  }

  //Show billing information or not
  ShowBilling = () => {
    if (this.EPayService.ePay) {
      if (this.EPayService.ePay.xmlPayment) {
        return this.EPayService.ePay.xmlPayment.ePayOptions.showBilling;
      }
    }
    return true;
  }

  //Show billing information or not
  AllowRecurring = () => {
    if (this.EPayService.ePay) {
      if (this.EPayService.ePay.xmlPayment.ePayOptions.profile) {
        if (this.EPayService.ePay.xmlPayment.ePayOptions.profile == "Y" || this.EPayService.ePay.xmlPayment.ePayOptions.profile.length > 10) {
          return true;
        }
      }
    }
    return false;
  }

  get selectedPaymentOption(): number | null | undefined
  {
    return this.ParseInt(this.EPayService.ePay?.paymentPage?.paymentOption);
  }

  get amount(): number | null | undefined {
    return this.EPayService.ePay?.paymentPage?.amount;
  }

  get serviceAmount(): number {
    return this.EPayService.ePay?.paymentPage?.serviceAmount ? this.EPayService.ePay.paymentPage.serviceAmount : 0;
  }

  get bankStatement() {
    return this.EPayService.ePay?.paymentPage?.bankStatement
  }

  get credit_card() {
    return this.EPayService.ePay?.paymentPage?.credit_card;
  }

  get processState() {
    return this.EPayService.ePay?.iotp?.processState;
  }

  get hsn() {
    return this.device?.hsn;
  }

  get fullName() {
    return this.EPayService?.ePay?.paymentPage.cardHolderName;
  }

  //Show the payment options
  PaymentOptions = (): Session_PaymentModel[] => {    
    var options = this.EPayService.ePay?.xmlPayment?.paymentOptions?.payment.filter((s) => s.enabled);
    return options ? options : [];
  }

  //Use saved token
  UseBilling = (billing: Session_BillingModel) => {
    this.isSubmitting = true;
    this.FormService.BillingPaymentResults(billing).subscribe(() => {
      this.isSubmitting = false;
      this.cdRef.markForCheck();
      this.cdRef.detectChanges();
    }
    );
  }

  //Removed saved token
  RemoveBilling = (billing: Session_BillingModel) => {
    this.isSubmitting = true;
    this.FormService.RemoveBillingPaymentResults(billing).subscribe(() => {
      this.isSubmitting = false;
      this.cdRef.markForCheck();
      this.cdRef.detectChanges();
    }
    );
  }

  //Submit ACH Payment
  AchPaymentResults = () => {
    if (!this.allowAgree || this.CurrentPage() !== 'payment') {
      return;
    }
    this.refreshScreen = false;
    this.isSubmitting = true;
    this.recaptcha3.getToken({ action: this.EPayService.ePay?.paymentPage.captchaaction }).then(token => {
      if (this.EPayService.ePay?.paymentPage?.cardData?.opaqueData) {
        this.EPayService.ePay.paymentPage.cardData.opaqueData.dataValue = token;

        this.FormService.AchPaymentResults().subscribe(() => {
          this.isSubmitting = false;
          if (this.EPayService.ePay?.paymentPage.ach) {
            this.EPayService.ePay.paymentPage.ach.accountNumber = '';
            this.EPayService.ePay.paymentPage.ach.routingNumber = '';
          }
          this.account_Numberdup = '';
          if (this.EPayService.ePay?.paymentPage?.cardData?.opaqueData) {
            if (this.EPayService.ePay.paymentPage.cardData.opaqueData.dataDescriptor == "captchaFailure") {
              this.EPayService.ePay.paymentPage.cardData.opaqueData.dataDescriptor = '';
              this.agree = false;
            }
          }
          this.refreshScreen = true;
          this.cdRef.markForCheck();
          this.cdRef.detectChanges();
        }
        );
      }
    }, error => {
      throw error;
    });
  }

  //Get the agency style sheet
  AgencyStyleSheet = () => {
    return this.FormService.AgencyStyleSheet();
  }

  //Display html on the page
  ScreenValue = (value: string): any => {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

  ngAfterViewChecked() {
    //Init the ePay set widths and styling for drop down list and text boxes.
    if (this.FormService.EPayService.ePay) {
      this.sizeLimit();

      this.RequiredAnswerMessage = '';
      this.FormService.Calculation();
      this.FormService.validate();

      this.CopyStylesForInput(document.getElementsByClassName("k-widget"));
      this.title.setTitle(this.toHTML(this.AgencyName()));
      //console.info('ePay', this.EPayService.ePay);
    }
    
    //Show the save toekn option
    if (this.ShowBilling()) {
      if (this.form) {
        this.allowAgree = true;
        if (this.billing_firstname) {
          this.allowAgree = this.allowAgree && this.billing_firstname.valid;
        }
        if (this.billing_lastname) {
          this.allowAgree = this.allowAgree && this.billing_lastname.valid;
        }
        if (this.billing_address1) {
          this.allowAgree = this.allowAgree && this.billing_address1.valid;
        }
        if (this.billing_city) {
          this.allowAgree = this.allowAgree && this.billing_city.valid;
        }
        if (this.billing_zipcode) {
          this.allowAgree = this.allowAgree && this.billing_zipcode.valid;
        }
        if (this.billing_phone) {
          this.allowAgree = this.allowAgree && this.billing_phone.valid;
        }
      }
    }
    else {
      this.allowAgree = true;
    }

    this.cdRef.detectChanges();
  }

  private timeout: number = 0;

  sendWalletPayment(brand: string, appleObject: any) {
    this.recaptcha3.getToken({ action: this.EPayService.ePay?.paymentPage.captchaaction }).then(token => {

      var storageCheck = localStorage.getItem("isSending");
      if (storageCheck != null) {
        var check = localStorage.getItem("isSending");
        if (check == "true") {
          return;
        }
      }

      if (this.EPayService?.ePay?.paymentPage.credit_card && !this.isSending && !this.isSubmitting) {
        localStorage.setItem("isSending", "true");
        this.isSending = true;
        this.isSubmitting = true;
        this.refreshScreen = false;

        if (this.EPayService.ePay?.paymentPage?.cardData?.opaqueData) {
          this.EPayService.ePay.paymentPage.cardData.opaqueData.dataValue = token;
          this.EPayService.ePay.paymentPage.cardData.brand = brand;

          this.FormService.PerformPayment(this.EPayService.ePay.paymentPage.credit_card).subscribe((data) => {
            if (appleObject) {
              if (this.EPayService.ePay) {
                if (this.EPayService.ePay.iotp.processState === 'CompletedOk') {
                  appleObject.complete('success');
                }
              }
              appleObject.complete('fail');
            }
            this.isSending = false;
            this.isSubmitting = false;
            if (this.EPayService.ePay?.paymentPage.cardData?.opaqueData?.dataDescriptor == "captchaFailure") {
              this.EPayService.ePay.paymentPage.cardData.opaqueData.dataDescriptor = '';
              this.agree = false;
            }
            if (this.carddata) {
              this.carddata.cvv = '';
            }
            this.cdRef.markForCheck();
            this.cdRef.detectChanges();
            this.refreshScreen = true;
            localStorage.removeItem("isSending");
          }
            , (error: any) => {
              this.isSending = false;
              this.isSubmitting = false;
              localStorage.removeItem("isSending");
              throw error;
            }
          );
        }
      }
    });
  }

  //Send the card payment
  sendCardPayment = (submitPayment: boolean) => {
    if (!this.isCardDataValid || !this.allowAgree || this.isSending || this.CurrentPage() !== 'payment') {
      return;
    }
    this.refreshScreen = false;

    this.botDetection().subscribe(() => {
      // generate new token
      if (this.EPayService.ePay?.paymentPage) {
        this.recaptcha3.getToken({ action: this.EPayService.ePay.paymentPage.captchaaction }).then(token => {
          this.isSending = true;
          this.isSubmitting = submitPayment;

          if (!this.EPayService.ePay?.paymentPage.cardHolderName && this.EPayService.ePay?.paymentPage) {
            this.EPayService.ePay.paymentPage.cardHolderName = this.EPayService.ePay.paymentPage.firstName + ' ' + this.EPayService.ePay.paymentPage.lastName;
          }
          if (this.EPayService.ePay?.paymentPage.cardData) {
            this.EPayService.ePay.paymentPage.cardData.brand = this.secureData.brand;
            this.EPayService.ePay.paymentPage.cardData.expiry = this.secureData.expiry;
            this.EPayService.ePay.paymentPage.cardData.cvv = this.secureData.cvv;
            this.EPayService.ePay.paymentPage.cardData.token = this.secureData.message;
            this.EPayService.ePay.paymentPage.cardData.fullName = this.EPayService.ePay.paymentPage.cardHolderName;

            if (this.allowRecurring && this.EPayService.ePay.paymentPage.cardData.profile === "N") {
              this.EPayService.ePay.paymentPage.cardData.profile = "Y";
            }

            if (this.EPayService.ePay.paymentPage.cardData.opaqueData && this.EPayService.ePay.paymentPage.credit_card) {
              this.EPayService.ePay.paymentPage.cardData.opaqueData.dataValue = token;

              this.FormService.PerformPayment(this.EPayService.ePay.paymentPage.credit_card).subscribe((data) => {
                this.isSending = false;
                this.isSubmitting = false;
                if (this.EPayService.ePay?.paymentPage.cardData?.opaqueData?.dataDescriptor == "captchaFailure") {
                  this.EPayService.ePay.paymentPage.cardData.opaqueData.dataDescriptor = '';
                  this.agree = false;
                }
                if (this.carddata) {
                  this.carddata.cvv = '';
                }
                this.cdRef.markForCheck();
                this.cdRef.detectChanges();
                this.refreshScreen = true;
              }
                , (error: any) => {
                  this.isSending = false;
                  throw error;
                }
              );
            }
          }
        }, (error: any) => {
          this.isSending = false;
          throw error;
        }
        );
      }
    });
  }

  public botDetection(): Observable<boolean> {
    return new Observable<boolean>(observer => {
      // Timeout to wait for the user to move the mouse or complete the form
      if (!this.mouseMoved && Date.now() - this.startTime < 30000) {
        // If mouse didn't move
        this.showCaptchaDialog().subscribe(result => observer.next(result));
      } else {
        // If all validations passed
        observer.next(true);
      }
    });
  }

  private showCaptchaDialog(): Observable<boolean> {
    // Assuming you have a component for your captcha dialog
    const dialogRef = this.dialog.open(CaptchaComponent, {
      width: '300px',
      data: {}, // Pass any data needed for the captcha
      disableClose: true // Prevent the dialog from being closed
    });

    return dialogRef.afterClosed();
  }


  //Displays the html
  toHTML(input: any): any {
    return new DOMParser().parseFromString(input, "text/html").documentElement.textContent;
  }

  //Check size limit of the drown down list
  sizeLimit = () => {
    this.FormService.sizeLimit();
  }

  //Replicate the stylings to the inner html tages
  CopyStylesForInput = (tags: HTMLCollectionOf<Element>) => {
    each(tags,
      (tag) => {
        let attr;
        if (tag.hasAttribute("style")) {
          var style = tag.attributes.getNamedItem("style");
          if (style) {
            attr = style.value;
          }
        }
        if (attr) {
          let inputs = tag.getElementsByTagName("input");
          each(inputs,
            input => {
              if (!input.hasAttribute("style")) {
                input.setAttribute("style", attr);
              }
            });
        }
      });
  }

  //Determine if in testing mode
  IsInTestingMode = () => {
    if (this.FormService) {
      if (this.FormService.EPayService) {
        if (this.FormService.EPayService.ePay) {
          if (this.FormService.EPayService.ePay.xmlPayment) {
            if (this.FormService.EPayService.ePay.xmlPayment.agency) {
              if (this.FormService.EPayService.ePay.xmlPayment.agency.type) {
                return !(this.FormService.EPayService.ePay.xmlPayment.agency.type === 'Production' || this.FormService.EPayService.ePay.xmlPayment.agency.type === 'Authorization');
              }
            }
          }
        }
      }
    }
  }

  //Allow capture or token without making a payment
  IsAuthorizeOnly = () => {
    if (this.EPayService.ePay?.paymentPage.amount && this.FormService.EPayService.ePay?.xmlPayment.agency) {
      return this.FormService.EPayService.ePay.xmlPayment.agency.tempAuthorize && this.EPayService.ePay.paymentPage.amount > 0;
    }
    else {
      return false;
    }
  }

  //Determine if page is valid
  IsPageValid = () => {
    let formvalid: boolean = true;

    if (!this.FormService.IsPageValid()) {
      formvalid = false;
    }

    if (this.PreQuestionaireComponents) {
      this.PreQuestionaireComponents.forEach(
        (item) => {
          if (!item.valid) {
            formvalid = false;
          }
        });
    }
    return formvalid;
  }

  //Determine if form is valid
  IsFormValid = () => {
    return this.FormService.IsFormValid() && this.IsPageValid();
  }

  //Determine if questionaire is valid
  PreQuestionare = () => {
    return this.FormService.HasPreQuestionare();
  }

  private questions: Array<Session_PreQuestionNumberModel> | null | undefined = null;

  //Get the questions
  preQuestionItems = () => {
    if (JSON.stringify(this.questions) !== JSON.stringify(this.FormService.loadPageQuestions())) {
      console.info("reloadPageQuestions", this.questions);
      this.questions = this.FormService.loadPageQuestions();
    }
    return this.questions;
  }

  //Get the next page
  NextPage = () => {
    this.refreshScreen = false;
    this.questions = null;
    // generate new token
    this.recaptcha3.getToken({ action: this.EPayService.ePay?.paymentPage.captchaaction }).then(token => {
      if (this.EPayService.ePay?.paymentPage?.cardData?.opaqueData) {
        this.EPayService.ePay.paymentPage.cardData.opaqueData.dataValue = token;

        this.questions?.forEach((q: Session_PreQuestionNumberModel) => {
          if (q.typeId == 2) {
            if (q.value) {
              if (dayjs(q.value).isValid()) {
                var dt = new Date(q.value);
                q.value = dayjs(q.value).format("MM/DD/YYYY");
              }
            }
          }
        });

        this.FormService.NextPage().subscribe(
          () => {
            this.isSubmitting = false;
            this.cdRef.markForCheck();
            this.cdRef.detectChanges();
            this.refreshScreen = true;
          }
        );
      }
    }, error => {
      this.isSending = false;
      throw error;
    });
  }

  //Get the previous page
  PreviousPage = () => {
    this.questions = null;
    this.refreshScreen = false;
    this.recaptcha3.getToken({ action: this.EPayService.ePay?.paymentPage.captchaaction }).then(token => {
      if (this.EPayService.ePay?.paymentPage?.cardData?.opaqueData) {
        this.EPayService.ePay.paymentPage.cardData.opaqueData.dataValue = token;
        this.FormService.PreviousPage().subscribe(
          () => {
            this.isSubmitting = false;
            this.cdRef.markForCheck();
            this.cdRef.detectChanges();
            this.refreshScreen = true;

            if (this.secureData.valid) {
              var token = new Token();
              token.valid = false;
              this.secureData = token;
            }
          });
      }
    }, error => {
      this.isSending = false;
      throw error;
    });
  }

  //Detemines if this is the first page
  IsFirstPage = () => {
    return this.FormService.IsFirstPage();
  }

  //Detemines if this is the last page
  IsLastPage = () => {
    return this.FormService.IsLastPage();
  }

  //Recalculate the payment amount
  ReCalcuatePaymentAmount = () => {
    this.refreshScreen = false;
    return this.FormService.ReCalculateAmount().subscribe(
      () => {
        this.refreshScreen = true;
        this.cdRef.markForCheck();
        this.cdRef.detectChanges();
      });
  }

  //Parse a number
  ParseInt = (value: any) => {
    return parseInt(value);
  }

  //Get the current page
  CurrentPage = (): string => {
    return this.FormService.CurrentPage;
  }

  //Get the agency name
  AgencyName = (): string => {
    return this.FormService.AgencyName;
  }

  //Get the error messages
  errorMessages = () => {
    return _filter(this.FormService.errorMessages(),
      (data) => {
        if (data) {
          return this.sanitizer.bypassSecurityTrustHtml(data);
        }
      }
    );
  }

  //Cancel making a payment
  cancel = () => {
    if (this.FormService.EPayService.ePay?.xmlPayment.agency.page) {
      window.location.href = this.FormService.EPayService.ePay.xmlPayment.agency.page;
    }
  }

  get selectedDevice(): any {
    return this._selectedDevice;
  }

  set selectedDevice(device: any) {
    console.info('selectedDevice', device);
    if (device !== undefined) {
      this._selectedDevice = device;
    }
    console.info('_selectedDevice', this._selectedDevice);
  }

  get devices(): Session_Device[] {
    if (this.FormService && this.FormService.EPayService && this.FormService.EPayService.ePay && this.FormService.EPayService.ePay.xmlPayment
      && this.FormService.EPayService.ePay.xmlPayment.devices) {
      return this.FormService.EPayService.ePay.xmlPayment.devices.device.filter((device: any) => device.enabled);
    }
    return [];
  };

  get device(): Session_Device | null | undefined {
    if (this.FormService && this.FormService.EPayService && this.FormService.EPayService.ePay && this.FormService.EPayService.ePay.xmlPayment
      && this.FormService.EPayService.ePay.xmlPayment.devices) {
      return this.FormService.EPayService.ePay.xmlPayment.devices.device.filter((device: any) => device.enabled)[0];
    }
    return null;
  };

  loadDevices(): any[] {
    if (this.FormService && this.FormService.EPayService && this.FormService.EPayService.ePay && this.FormService.EPayService.ePay.xmlPayment
      && this.FormService.EPayService.ePay.xmlPayment.devices) {
      return this.FormService.EPayService.ePay.xmlPayment.devices.device.filter((device: any) => device.enabled);
    }
    return [];
  }

  cancelTerminal() {
    if (this.selectedDevice && this.FormService) {
      this.FormService.deviceCancelRequest().subscribe((result: any) => {
        console.log('cancelTerminal', this.FormService.EPayService);
        this.isTerminalSubmitting = false;
      });
    }
  }

  useDevice(): void {
    if (!this.hasMultipleDevices()) {
      this.selectedDevice = this.device;
    }

    if (this.selectedDevice) {
      console.info('_selectedDevice', this._selectedDevice);
      this.isTerminalSubmitting = true;
      this.recaptcha3.getToken({ action: this.EPayService.ePay?.paymentPage.captchaaction }).then(token => {
        if (this.EPayService.ePay?.paymentPage.cardData?.opaqueData) {
          this.EPayService.ePay.paymentPage.cardData.opaqueData.dataValue = token;          
          this.FormService.deviceConnect(this.selectedDevice.hsn).subscribe(
            (result: any) => {
              console.info('Device connected:', result);
              if (result && result.paymentPage) {
                const paymentPage = result.paymentPage;
                if (paymentPage.bolt_snappay?.sessionKey) {
                  this.FormService.EPayService.ePay = result;
                  
                  console.info(
                    'Connected using session key',
                    paymentPage.bolt_snappay.sessionKey
                  );
                  this.isSubmitting = true;
                  this.FormService.deviceCharge().subscribe((chargeResult: any) => {
                    if (chargeResult.page == "refreshpayment") {
                      this.isSubmitting = false;
                      this.isTerminalSubmitting = false;
                    }
                    else {
                      this.EPayService.ePay = chargeResult;
                      this.NextPage();
                    }
                  });
                } else if (paymentPage.bolt_cardconnect?.sessionKey) {
                  this.FormService.EPayService.ePay = result;
                  console.info(
                    'Connected using session key',
                    paymentPage.bolt_cardconnect.sessionKey
                  );
                  this.isSubmitting = true;
                  this.FormService.deviceCharge().subscribe((chargeResult: Session_ePaySessionModel) => {
                    console.info('Charge result:', chargeResult);
                    if (chargeResult.page == "refreshpayment") {
                      this.isSubmitting = false;
                      this.isTerminalSubmitting = false;
                    }
                    else {
                      this.EPayService.ePay = chargeResult;
                      this.NextPage();
                    }
                  });
                }
              }
            });
        }
      },
        (error: any) => {
          console.error('Error connecting device:', error);
        }
      );
    }
  }

  useDeviceEnter(): void {
    if (!this.hasMultipleDevices()) {
      this.selectedDevice = this.device;
    }

    if (this.selectedDevice) {
      this.isTerminalSubmitting = true;
      this.recaptcha3.getToken({ action: this.EPayService.ePay?.paymentPage.captchaaction }).then(token => {
        if (this.EPayService.ePay?.paymentPage.cardData?.opaqueData) {
          this.EPayService.ePay.paymentPage.cardData.opaqueData.dataValue = token;
          this.FormService.deviceConnect(this.selectedDevice.hsn).subscribe(
            (result: any) => {
              console.info('Device connected:', result);
              if (result && result.paymentPage) {
                const paymentPage = result.paymentPage;
                if (paymentPage.bolt_snappay?.sessionKey) {
                  this.FormService.EPayService.ePay = result;
                  console.info(
                    'Connected using session key',
                    paymentPage.bolt_snappay.sessionKey
                  );
                  this.isSubmitting = true;
                  this.FormService.manualCharge().subscribe((chargeResult: any) => {
                    if (chargeResult.page == "refreshpayment") {
                      this.isSubmitting = false;
                      this.isTerminalSubmitting = false;
                    }
                    else {
                      this.EPayService.ePay = chargeResult;
                      this.NextPage();
                    }
                  });
                } else if (paymentPage.bolt_cardconnect?.sessionKey) {
                  this.FormService.EPayService.ePay = result;
                  console.info(
                    'Connected using session key',
                    paymentPage.bolt_cardconnect.sessionKey
                  );
                  this.isSubmitting = true;
                  this.FormService.manualCharge().subscribe((chargeResult: Session_ePaySessionModel) => {
                    console.info('Charge result:', chargeResult);
                    if (chargeResult.page == "refreshpayment") {
                      this.isSubmitting = false;
                      this.isTerminalSubmitting = false;
                    }
                    else {
                      this.EPayService.ePay = chargeResult;
                      this.NextPage();
                    }
                  });
                }
              }
            });
        }
      },
        (error: any) => {
          console.error('Error connecting device:', error);
        }
      );
    }
  }

  hasMultipleDevices(): boolean {
    return this.devices && this.devices.length > 1;
  }
}
